import subNavigationUrl from './subNavigation.html';

class SubNavigationController {
  constructor(Authentication, PersonaCollection, ShiftUtils, $rootScope) {
    'ngInject';

    Object.assign(this, { Authentication, PersonaCollection, ShiftUtils, $rootScope });
  }

  shouldShowTab(tab) {
    return (
      (!tab.show || tab.show()) && (!this.isShiftsTabs || this.ShiftUtils.shouldShowShiftsTab(tab))
    );
  }

  itemClicked(tab) {
    this.navAction({ value: tab.value });
    this.$rootScope.$emit('schedule-view-changed');
  }

  isInvalid(value) {
    const invalidTabs = this.getInvalidTabs() || [];
    return invalidTabs.includes(value);
  }

  getBadgesCount(tab) {
    if (!tab.getBadgesCount) {
      return 0;
    }

    return tab.getBadgesCount();
  }
}

export default {
  templateUrl: subNavigationUrl,
  controller: SubNavigationController,
  controllerAs: 'ctrl',
  transclude: true,
  bindings: {
    navTabs: '<',
    navActiveTab: '@',
    navAction: '&',
    getInvalidTabs: '&',
    isShiftsTabs: '<?',
  },
};
